import mountNecessityAndProportionalityParams from './mountNecessityAndProportionalityParams'

const dataTreatment = {
  mountNecessityAndProportionalityParams,
}

export default dataTreatment
